// extracted by mini-css-extract-plugin
export var active = "bF_bd";
export var categories = "bF_cY";
export var category = "bF_cZ";
export var icon = "bF_bw";
export var icons = "bF_bs";
export var image = "bF_k";
export var member = "bF_gF";
export var memberTitle = "bF_gG";
export var name = "bF_f0";
export var placeholder = "bF_bb";
export var section = "bF_j";
export var show = "bF_L";
export var subtitle = "bF_cq";
export var team = "bF_gD";